import { useMemo } from "react";

import { useTrack } from "pro-features/components/WithTrack/src/useTrack";

import createPlaybooksTrackingService from "../services/tracking/factory";

export const usePlaybooksTrackingService = () => {
    const [track] = useTrack();

    return useMemo(() => createPlaybooksTrackingService(track), [track]);
};
